// SavePdfModal.js
import React, { useEffect, useState } from "react";
import {
  Modal,
  Box,
  Typography,
  TextField,
  Button,
  Stack,
  IconButton,
   CircularProgress, 
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 360,
  bgcolor: "background.paper",
  borderRadius: 2,
  boxShadow: 24,
  p: 3,
};

export const SavePdfModal = ({ open, defaultFileName = "string_art_template.pdf", onClose, onSave }) => {
  const [fileName, setFileName] = useState(defaultFileName);
  const [isSaving, setIsSaving] = useState(false);

  useEffect(() => {
    if (open) {
      setFileName(defaultFileName || "string_art_template.pdf");
    }
  }, [open, defaultFileName]);

  // const handleSave = () => {
  //   // basic sanitization: trim and ensure .pdf
  //   const name = fileName.trim().length ? fileName.trim() : defaultFileName;
  //   const finalName = name.toLowerCase().endsWith(".pdf") ? name : `${name}.pdf`;
  //   onSave(finalName);
  // };

    const handleSave = () => {
    const name = fileName.trim().length ? fileName.trim() : defaultFileName;
    const finalName = name.toLowerCase().endsWith(".pdf") ? name : `${name}.pdf`;

    setIsSaving(true); // 👈 loader on

    
    const result = onSave(finalName);

    
    if (result && typeof result.finally === "function") {
      result.finally(() => setIsSaving(false));
    } else {
      setIsSaving(false);
    }
  };


  return (
    <Modal open={open}  aria-labelledby="save-pdf-modal">
      <Box sx={style}>
        <Stack direction="row" justifyContent="space-between" alignItems="center" mb={1}> 
          <Typography id="save-pdf-modal" variant="h5">Save String Art Template</Typography>
          {/* <IconButton size="small" onClick={onClose}><CloseIcon fontSize="small" /></IconButton> */}
        </Stack>

        <Typography variant="body2" color="text.secondary" mb={2}>
          Edit the filename below (it will be saved as a PDF). Then press Save.
        </Typography>

        <TextField
          fullWidth
          size="small"
          label="Filename"
          value={fileName}
          onChange={(e) => setFileName(e.target.value)}
          helperText="Don't include special characters. .pdf will be appended if missing."
        />

        {/* <Stack direction="row" spacing={2} justifyContent="flex-end" mt={3}>
         
           <Button
            onClick={onClose}
            variant="outlined"
            size="small"
            sx={{ textTransform: "none" }}
            disabled={isSaving}         
          >
            Cancel
          </Button>

          <Button
            onClick={handleSave}
            variant="contained"
            size="small"
            disabled={isSaving}          
            sx={{
              textTransform: "none",
              fontSize: { xs: 13, sm: 14 },
              mt: 2,
              bgcolor: "#111",
              color: "#fff",
              borderRadius: 1,
              "&:hover": { bgcolor: "#000" },
            }}
          >
            {isSaving ? (
              <Stack direction="row" spacing={1} alignItems="center">
                <CircularProgress size={16} sx={{ color: "black",marginLeft:1 }}/> 
              <span style={{ color: "black" }}>Saving...</span>        
              </Stack>
            ) : (
              "Save"
            )}
          </Button>
        </Stack> */}
        <Stack direction="row" spacing={2} justifyContent="flex-end" mt={3}>

  {/* CANCEL only when NOT saving */}
  {!isSaving && (
    <Button
      onClick={onClose}
      variant="outlined"
      size="small"
      sx={{ textTransform: "none" }}
    >
      Cancel
    </Button>
  )}

  <Button
    onClick={handleSave}
    variant="contained"
    size="small"
    disabled={isSaving}
    sx={{
      textTransform: "none",
      fontSize: { xs: 13, sm: 14 },
      mt: 2,
      bgcolor: "#111",
      color: "#fff",
      borderRadius: 1,
      "&:hover": { bgcolor: "#000" },
    }}
  >
    {isSaving ? (
      <Stack direction="row" spacing={1} alignItems="center">
        <CircularProgress size={16} sx={{ color: "black" }} />
        <span style={{ color: "black" }}>Saving...</span>
      </Stack>
    ) : (
      "Save"
    )}
  </Button>

</Stack>

      </Box>
    </Modal>
  );
};
